import Tooltip, {tooltipClasses, TooltipProps} from "@mui/material/Tooltip";
import {styled} from "@mui/material/styles";
import React from "react";
import IconButton from "@mui/material/IconButton";
import Icon from "./Icon";

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.extra.sidebar,
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 450,
        fontWeight: 400,
        lineHeight: "13pt",
        fontSize: "9.2pt",
        fontStyle: "italic",
    },
}));

const IconTooltip = ({title}: {title: string}) => {
    return (
        <StyledTooltip title={title} >
            <IconButton style={{fontSize: "18px", color: "#0064FF"}}>
                <Icon icon="fal circle-info" fixedWidth={true} />
            </IconButton>
        </StyledTooltip>
    );
}

export default IconTooltip;